import { BrButton, BrDivider } from '@govbr-ds/react-components';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { ArrecadacaoContext } from '../contexts/ArrecadacaoContext';
import { ICrumb } from '../interfaces/ICrumb';
import TituloSection from '../components/tituloSection/tituloSection';
import { useAuth } from 'hooks/useAuth';
import styles from './Arrecadacao.module.scss';
import CustomLoading from 'components/customLoading/customLoading';
import ListaGuias from './ListaGuias/ListaGuias';

function Arrecadacao() {
  const auth = useAuth();
  const navigate = useNavigate();
  const context = useContext(ArrecadacaoContext);

  useEffect(() => {
    const crumbs: ICrumb[] = [
      {
        isHome: true,
        label: 'home',
        onClick: () => {
          navigate('/');
        },
      },
    ];
    context?.setCrumbs(crumbs);
  }, []);

  useEffect(() => {
    if (auth.isLoading === false && auth.isAuthenticated === false) {
      auth.login();
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  if (auth.isAuthenticated) {
    return (
      <>
        <BrDivider />
        <TituloSection />
        <ListaGuias />
      </>
    );
  } else {
    return (
      <div className={styles.container}>
        <CustomLoading label='Redirecionando para a tela de Login. Clique no botão abaixo para ser redirecionado imediatamente.'>
          <BrButton secondary onClick={() => auth.login()}>
            Login
          </BrButton>
        </CustomLoading>
      </div>
    );
  }
}

export default Arrecadacao;
